import { render, staticRenderFns } from "./DropDownButtonBlob.vue?vue&type=template&id=580f84c4&scoped=true"
import script from "./DropDownButtonBlob.vue?vue&type=script&lang=js"
export * from "./DropDownButtonBlob.vue?vue&type=script&lang=js"
import style0 from "./DropDownButtonBlob.vue?vue&type=style&index=0&id=580f84c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f84c4",
  null
  
)

export default component.exports